export function formatNumber (value, setting) {
	var separator = '$1' + setting.digitGroupingSeparator

	if ((setting.decimalSeparator !== '.') && (value.indexOf('.') > 0)) {
		value = value.replace('.', setting.decimalSeparator)
	} else {
		value = value.replace(',', setting.decimalSeparator)
	}

	if (setting.digitGroupingPattern !== '0') {
		if ((value.indexOf('.') > 0) || (value.indexOf(',') > 0)) {
			return value.replace(/(\d)(?=(\d\d\d)+([^\d]|$)(.|,))/g, separator)
		} else {
			return value.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, separator)
		}
	}
	return value
}

/**
 * Only for attributes groups
 * @param {attributesGroups} arr
 * @return []
 */
export function flatDeepAttributes (arr) {
	return Infinity > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val.attributes) ? flatDeepAttributes(val.attributes, Infinity - 1) : val.title), []) : arr.slice()
}
